<template>
  <div class="toasts-outer">
    <TransitionGroup name="list">
        <ToastItem
          v-for="noti in notifications"
          :message="noti.message"
          :createdAt="noti.createdAt"
          :id="noti.id"
          :key="noti.id"
        />
    </TransitionGroup>
  </div>
</template>

<script>
import ToastItem from './ToastItem'

export default {
  computed: {
    notifications() {
      return this.$store.getters['getNotifications']
    }
  },
  mounted() {
    // this.$notify('hello')
  },
  components: {
    ToastItem
  },
}

</script>

<style lang="scss" scoped>

.toasts-outer {
  position: fixed;
  z-index: 999;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 24px;
}

.toasts-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.2s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>